import Http from '../utils/http'
import store from 'store/index'

export const create = (deal, quotation, payload) => {
    return Http.post(`/deals/${deal}/quotations/${quotation}/charges`, payload)
       .then(response => store.dispatch('saveQuotation', response.data))
}

export const update = (deal, quotation, id, payload) => {
    return Http.put(`/deals/${deal}/quotations/${quotation}/charges/${id}`, payload)
       .then(response => store.dispatch('saveQuotation', response.data))
}

export const destroy = (deal, quotation, id) => {
    return Http.delete(`/deals/${deal}/quotations/${quotation}/charges/${id}`)
           .then(response => store.dispatch('saveQuotation', response.data))
}



// WEBPACK FOOTER //
// ./src/services/quotation-charges.js